export const CATEGORY_OPTIONS = [
  {
    value: 'new_idea',
    label: 'New Idea',
    description: 'For entrepreneurs with early-stage ideas looking for cofounders or collaborators.',
    icon: '',
    color: '#10b981',
    bgColor: '#d1fae5'
  },
  {
    value: 'technical_cofounder',
    label: 'Technical Co-founder',
    description: 'For those needing a tech partner to build and scale their product.',
    icon: '',
    color: '#3b82f6',
    bgColor: '#dbeafe'
  },
  {
    value: 'business_cofounder',
    label: 'Business Co-founder',
    description: 'For technical founders looking for a partner with business, marketing, or operations skills.',
    icon: '',
    color: '#8b5cf6',
    bgColor: '#ede9fe'
  },
  {
    value: 'investor',
    label: 'Investor',
    description: 'For entrepreneurs looking for early-stage funding or investors interested in supporting a startup.',
    icon: '',
    color: '#f59e0b',
    bgColor: '#fef3c7'
  },
  {
    value: 'advisor',
    label: 'Advisor',
    description: 'For founders looking for mentorship or strategic advice from experienced industry professionals.',
    icon: '',
    color: '#14b8a6',
    bgColor: '#ccfbf1'
  },
  {
    value: 'partner',
    label: 'Partner',
    description: 'For those seeking partnerships with other companies or teams to collaborate on business growth and product development.',
    icon: '',
    color: '#6366f1',
    bgColor: '#e0e7ff'
  },
  {
    value: 'early_engineer',
    label: 'Early Engineer',
    description: 'For those seeking the first engineers to help develop and launch the product.',
    icon: '',
    color: '#06b6d4',
    bgColor: '#cffafe'
  },
  {
    value: 'freelancer',
    label: 'Freelancer',
    description: 'For founders needing short-term expertise in specific areas like design, content, marketing, etc.',
    icon: '',
    color: '#ec4899',
    bgColor: '#fce7f3'
  }
];

export const getCategoryConfig = (value) => {
  return CATEGORY_OPTIONS.find(cat => cat.value === value) || CATEGORY_OPTIONS[0];
};
